module.exports = __webpack_public_path__ + "static/sport/login.e8cd61a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/login.gif
// module id = BdPa
// module chunks = 0